export const initialMenuState = {
  isLoading: false,
  selectedMenu: '',
  isSideNavOpened: false
};
